import { List } from 'immutable';
import { debtValuationConstants } from '../constants';

export function debt_valuations(state = {}, action) {
  switch (action.type) {
    case debtValuationConstants.DEBT_VALUATION_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case debtValuationConstants.DEBT_VALUATION_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case debtValuationConstants.DEBT_VALUATION_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case debtValuationConstants.DEBT_VALUATION_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case debtValuationConstants.DEBT_VALUATION_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case debtValuationConstants.DEBT_VALUATION_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case debtValuationConstants.DEBT_VALUATION_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case debtValuationConstants.DEBT_VALUATION_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const debtValuationIndex = state.items.findIndex(val => val.id == action.response.id);

      if (debtValuationIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(debtValuationIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case debtValuationConstants.DEBT_VALUATION_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case debtValuationConstants.DEBT_VALUATION_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case debtValuationConstants.DEBT_VALUATION_DELETE_SUCCESS: {
      const { debtValuationId } = action;

      if (!state.items) {
        return state;
      }

      const debtValuationIndex = state.items.findIndex(val => val.id == debtValuationId);

      if (debtValuationIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(debtValuationIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case debtValuationConstants.DEBT_VALUATION_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case debtValuationConstants.DEBT_VALUATION_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
